import { render, staticRenderFns } from "./uodoComplaintsList.vue?vue&type=template&id=6caead7e&scoped=true"
import script from "./uodoComplaintsList.vue?vue&type=script&lang=js"
export * from "./uodoComplaintsList.vue?vue&type=script&lang=js"
import style0 from "./uodoComplaintsList.vue?vue&type=style&index=0&id=6caead7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6caead7e",
  null
  
)

export default component.exports